class AANLoginDialog {
	private loginDialog?: HTMLDialogElement;

	displayLoginError() {
		if (window.location.toString().indexOf("LoginError=true") === -1) {
			return;
		}

		const loginErrorElement = document.querySelector("#loginDialog .login-error") as HTMLSpanElement;
		loginErrorElement.innerText = "The Username or Password provided is incorrect.";
	}

	init() {
		this.loginDialog = document.querySelector("#loginDialog") as HTMLDialogElement;

		if (!this.loginDialog) {
			return;
		}

		const form: HTMLFormElement | null = this.loginDialog.querySelector("form");
		form?.addEventListener("submit", event => {
			this.loginDialog?.classList.add("submitted");
		});

		this.displayLoginError();
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const loginDialog = new AANLoginDialog();

	loginDialog.init();
});
